// onboardingBusinessCreated definition
export default function (businessId) {
  return this.sendEvent('onboarding.businessCreated', { businessId })
}
